import { useEffect } from 'react'
import { BrowserRouter, Routes, Route, useParams, useNavigate } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { AppProvider } from './context/AppContext'
import HomePage from './pages/home/HomePage'
import PrivacyPage from './pages/PrivacyPage'
import TermsPage from './pages/TermsPage'
import { LANGUAGES } from './i18n'

const VALID_CODES = new Set(LANGUAGES.map((l) => l.code))

// Reads /:lang from the URL, sets i18n language, then renders the app
function LangRoute() {
  const { lang } = useParams<{ lang: string }>()
  const { i18n } = useTranslation()
  const navigate = useNavigate()

  useEffect(() => {
    const code = lang?.toLowerCase() ?? ''
    if (VALID_CODES.has(code)) {
      i18n.changeLanguage(code as string)
    } else {
      // Unknown lang segment — redirect to root
      navigate('/', { replace: true })
    }
  }, [lang, i18n, navigate])

  return <HomePage />
}

export default function App() {
  return (
    <BrowserRouter>
      <AppProvider>
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/privacy" element={<PrivacyPage />} />
          <Route path="/terms" element={<TermsPage />} />
          <Route path="/:lang" element={<LangRoute />} />
          <Route path="/:lang/*" element={<LangRoute />} />
        </Routes>
      </AppProvider>
    </BrowserRouter>
  )
}
